import { useState } from "react";

import { PasswordInputView } from "./PasswordInputView";

interface PasswordInputProps {
  id?: string;
  name?: string;
  value: string;
  placeholder?: string;
  label?: string;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  autoComplete?: string;
  onChange: (value: string) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  className?: string;
  wrapperClassName?: string;
  validate?: (value: string) => string | undefined;
}

export const PasswordInput = ({
  value,
  onChange,
  validate,
  error: externalError,
  ...props
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [internalError, setInternalError] = useState<string | undefined>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);

    if (validate) {
      const validationError = validate(newValue);
      setInternalError(validationError);
    } else {
      setInternalError(undefined);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (validate) {
      const validationError = validate(e.target.value);
      setInternalError(validationError);
    }
    props.onBlur?.(e);
  };

  const error = externalError || internalError;

  return (
    <PasswordInputView
      {...props}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      showPassword={showPassword}
      onToggleVisibility={() => setShowPassword(!showPassword)}
    />
  );
};
